import React, { useState } from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import { translate } from '../../../services/translate';
import FormInput from '../../../components/FormInput';
import BasicModal from '../../../components/BasicModal';
import { WindowInformation } from '../../../services/window-information';
import FontWeight from '../../../styles/fontWeights';


interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onConfirm: () => Promise<void | false>;
    onReject: (message: string) => Promise<void | false>;
}
export default function ReviewModal({ isModalVisible, setModalVisible, onConfirm, onReject }: ModalProps) {
    const { styles } = useStyles(styleSheet);

    const [isRejecting, setIsRejecting] = useState(false);
    const [reason, setReason] = useState('');
    const windowInfo = WindowInformation();

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            width='medium'
            mobileHeight='fit'
            title={translate('reviewMaintenanceRequest')}
            cancelButton={{
                onClick: () => {
                    setIsRejecting(false);
                    setReason('');
                }
            }}
            primaryButton={!isRejecting ? {
                onClick: onConfirm,
                text: translate('confirm'),
            } : {
                onClick: async () => await onReject(reason),
                text: translate('reject'),
            }}
            secondaryButton={!isRejecting ? {
                text: translate('reject'),
                onClick: () => setIsRejecting(true),
            } : {
                text: translate('goBack'),
                onClick: () => setIsRejecting(false),
            }}
        >
            {!isRejecting ? <View style={{ height: !windowInfo.isMobile ? 188 : undefined }}>
                <View style={{ gap: 10 }}>
                    <MyAppText style={styles.subheader}>{translate('waitingForYourReviewText1')}</MyAppText>
                    <MyAppText style={styles.subheader}>{translate('waitingForYourReviewText2')}</MyAppText>
                    <View>
                        <View style={{ flexDirection: 'row', gap: 5 }}>
                            <MyAppText style={[styles.subheader, styles.bold]}>{translate('confirm')}:</MyAppText>
                            <MyAppText style={styles.subheader}>{translate('confirmMaintenanceRequest')}</MyAppText>
                        </View>
                        <View style={{ flexDirection: 'row', gap: 5 }}>
                            <MyAppText style={[styles.subheader, styles.bold]}>{translate('reject')}:</MyAppText>
                            <MyAppText style={styles.subheader}>{translate('rejectMaintenanceRequest')}</MyAppText>
                        </View>
                    </View>
                </View>
            </View> : <View style={{ height: !windowInfo.isMobile ? 188 : undefined }}>
                <View style={{ flex: 1 }}>
                    <MyAppText style={styles.subheader}>{translate('addReasonForRejection')}:</MyAppText>
                    <FormInput
                        placeholder={translate('reason')}
                        value={reason}
                        onChangeText={setReason}
                        invalid={(value: string) => {
                            return value == '';
                        }}
                        multiline
                        numberOfLines={3}
                        maxLength={255}
                    />
                </View>
            </View>}
        </BasicModal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    subheader: {
        fontSize: 14,
        fontWeight: FontWeight.regular,
        flexWrap: 'wrap',
        color: theme.colors.modal.subheader,
    },
    bold: {
        fontWeight: FontWeight.bold,
    },
}));
